export default {"src":"/customer-services/_next/static/media/store.9910246b.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};